module.exports = __webpack_public_path__ + "media/images/meta/meta-eb82615fc1e56b3df1cc4ba0115561f2.jpg";